import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter, formatters } from '@cmg/data-grid';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export const valueFormatter = createValueFormatter<
  FirmInvestorContactsGridItemFragment,
  FirmInvestorContactsGridItemFragment['titles']
>({
  gridRow: ({ value }) => {
    return formatters.truncatedArrayValueFormatter(value, 3);
  },
});

export function getTooltipContent({
  value,
}: {
  value: FirmInvestorContactsGridItemFragment['titles'] | null | undefined;
}) {
  if (isNil(value) || isEmpty(value)) {
    return;
  }
  return () => value.join(', ');
}

export const titlesColDef: ServerColDef<FirmInvestorContactsGridItemFragment> = {
  field: 'titles',
  headerName: 'Title(s)',
  tooltipField: 'titles',
  valueFormatter,
  tooltipComponentParams: {
    getContent: getTooltipContent,
  },
  context: {
    sortFieldPath: 'titlesDisplayValue',
    filterFieldPath: 'titlesDisplayValue',
  },
};
